import { Button, Flex, TextInput } from "@mantine/core";
import { FormRow, FormColumn } from "../components/common/Form/FormRow";
import Container from "../components/common/Container";
import PageHeader from "../components/common/PageHeader";
import { useAuth } from "../context/AuthContext";
import { useForm } from "@mantine/form";
import { creationNotification } from "../utils/useNotification";
import {
  combineValidators,
  validateMinLength,
  validateNoSpaces,
  validatePhoneNumberIsNumeric,
  validatePhoneNumberStartsWithZero,
  validateRequired,
} from "../utils/validations";
import CustomSelect from "../components/common/Inputs/CustomSelect";
import CustomDatePicker from "../components/common/Inputs/CustomDatePicker";
import { CreateEmployeeParams } from "../types/types";
import { CustomMultiSelect } from "../components/common/Inputs/MultiSelectInput";
import { createApplicant } from "../api/applicantApi";
import PlusIcon from "../components/common/Icons/PlusIcon";
import { useRef } from "react";

const NewApplicant = () => {
  const {
    roleSelectData,
    skillSelectData,
    departmentSelectData,
    contractSelectData,
  } = useAuth();
  const formRef = useRef<HTMLFormElement>(null);

  const form = useForm<CreateEmployeeParams>({
    initialValues: {
      name: "",
      phone: "",
      employmentType: "",
      departmentIds: [],
      roleIds: [],
      contractId: "",
      assignedSkillIds: [],
      hireDate: undefined,
      isWorkingCurrently: true,
      birthday: undefined,
    },
    validate: {
      name: validateRequired,
      phone: combineValidators(
        validateRequired,
        validatePhoneNumberStartsWithZero,
        validatePhoneNumberIsNumeric,
        validateNoSpaces,
        validateMinLength(11)
      ),
      departmentIds: validateRequired,
      roleIds: validateRequired,
      contractId: validateRequired,
      assignedSkillIds: validateRequired,
      birthday: validateRequired,
    },
  });

  const handleSubmit = async (values: CreateEmployeeParams) => {
    try {
      const birthday = new Date(values.birthday);
      birthday.setUTCHours(0, 0, 0, 0);

      const { data, response }: any = await createApplicant({
        ...values,
        birthday: birthday.toISOString(),
      });

      if (data?.success) {
        creationNotification("Başvuru", data.success);
        form.reset();
        form.setFieldValue("contractId", null);
        return;
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <Container>
      <PageHeader
        pageTitle="Yeni Başvuru Kaydı"
        isButtoned
        buttonText="Oluştur"
        buttonIcon={<PlusIcon />}
        buttonOnClick={() => formRef.current?.requestSubmit()}
      />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "40px",
        }}
      >
        <form
          ref={formRef}
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "24px",
          }}
          onSubmit={form.onSubmit(handleSubmit)}
        >
          <FormRow $gap={50}>
            <FormColumn>
              <TextInput
                label="Ad Soyad"
                placeholder="Ad Soyad Giriniz."
                radius={10}
                maxLength={40}
                w={"100%"}
                {...form.getInputProps("name")}
              />
              <TextInput
                label="Telefon"
                placeholder="05*********"
                radius={10}
                type="tel"
                w={"100%"}
                maxLength={11}
                {...form.getInputProps("phone")}
              />
              <CustomDatePicker
                label="Doğum Tarihi"
                placeholder="Tarih seçiniz."
                w="100%"
                {...form.getInputProps("birthday")}
              />
            </FormColumn>
            <FormColumn>
              <CustomMultiSelect
                label="Yetenekler"
                searchable
                placeholder="Yetenek seçiniz."
                w="100%"
                {...form.getInputProps("assignedSkillIds")}
                data={skillSelectData}
              />
              <CustomMultiSelect
                label="Rol"
                searchable
                placeholder="Rol Seçiniz."
                w="100%"
                {...form.getInputProps("roleIds")}
                data={roleSelectData}
              />
              <CustomMultiSelect
                label="Departman"
                searchable
                placeholder="Departman Seçiniz."
                w="100%"
                {...form.getInputProps("departmentIds")}
                data={departmentSelectData}
              />
              <CustomSelect
                label="Kontrat"
                searchable={true}
                placeholder="Kontrat seçiniz."
                w="100%"
                {...form.getInputProps("contractId")}
                data={contractSelectData}
              />
            </FormColumn>
          </FormRow>
        </form>
      </div>
    </Container>
  );
};

export default NewApplicant;
